<template>
    <div>
        <div class="bg-gray2">
            <div class="container-fluid">
                <!--/* Mobile */-->
                <div class="d-block d-sm-none py-2 mb-3 mt-2">
                    <div class="ob1-skeleton">
                        <div class="ob1-skeleton-gray2 mt-1 mb-2" style="width: 300px; height: 30px" />
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <skeleton-reco-mobile-card />
                        </div>
                    </div>
                </div>
                <!--/* Tablette */-->
                <div class="d-none d-sm-block d-lg-none py-2 mb-3 mt-2">
                    <div class="ob1-skeleton">
                        <div class="ob1-skeleton-gray2 mt-1 mb-2" style="width: 300px; height: 30px" />
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <skeleton-reco-mobile-card />
                        </div>
                        <div class="col-6">
                            <skeleton-reco-mobile-card />
                        </div>
                    </div>
                </div>
                <!--/* Desktop */-->
                <div class="d-none d-lg-block py-2 mb-3 mt-2">
                    <div class="ob1-skeleton">
                        <div class="ob1-skeleton-gray2 mt-1 mb-2" style="width: 500px; height: 30px" />
                    </div>
                    <div class="row">
                        <div v-for="x in 4" :key="'reco' + x" class="col-3">
                            <skeleton-reco-mobile-card />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="withSubtitle" class="container-fluid">
            <div class="ob1-skeleton">
                <div class="ob1-skeleton-white px-2 mt-2 mb-3" style="width: 300px; height: 30px" />
            </div>
        </div>
    </div>
</template>

<script>

import SkeletonRecoMobileCard from "./SkeletonRecoMobileCard.vue";

export default {
    name: "SkeletonRecoMobilesCard",
    components: {SkeletonRecoMobileCard},
    props: {
        withSubtitle: {
            type: Boolean,
            default: false,
            required: false
        }
    }
}
</script>
